import { FormControl, InputLabel, MenuItem, Paper, IconButton, Tab, Button, Divider, Grid, Select, Tabs, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { values } from "pdf-lib";
import routes from "../../Utils/routes";
import MentorshipContainer from "./Mentorship";
import Upcomingcalls from "./Upcomingcalls";
import React, { useContext, useEffect, useState } from 'react';
import { useStyles } from './style';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import { AuthUser } from '../../interfaces/Contexts';
import AppSearchBar from '../../Components/AppSearchBar';
import { featuredCardData } from "../Network/NetworkData";
import { getNetworks, getMentorshipDetails } from '../../Utils/apiService';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { useNavigate } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import MentorshipMobileview from "./Mentorship/MentorshipMobileview";
import Modal from '@mui/material/Modal';
import FilterIcon from '../../Assets/filter.svg';
import Menu from '@mui/material/Menu';
import RequestImage from '../../Assets/nomentors.svg';

const YourMentors: React.FunctionComponent<any> = (props) => {
    const AllYourMentors = props?.AllYourMentors;
    console.log(AllYourMentors, "AllYourMentorsAllYourMentors");

    const upcomingCalls = props?.upcomingCalls;
    const CallrequestbymeData = props?.CallrequestbymeData;
    const {
        state: { user },
    } = useContext(AuthContext);
    const userData = user as AuthUser;
    const classes = useStyles();
    const navigate = useNavigate();
    const [featuredCardData, setFeaturedCardData] = useState<any[]>([]);
    const [allFeaturedCardData, setAllFeaturedCardData] = useState<any[]>([]);
    const [selectedValues, setSelectedValues] = useState<any>({
        locations: [],
        graduationYear: '',
        currentCompany: '',
        postCompany: '',
        industry: '',
    });
    const [localSearchInput, setLocalSearchInput] = useState('');
    const [searchInput, setSearchInput] = useState<string>('');
    const [notificationOpen, setNotificationOpen] = useState(false);
    const [Sortby, setSortby] = useState('');
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const sortOptions = ["A - Z", "Z - A", "Recently joined"];
    const isSortMenuOpen = Boolean(anchorEl);
    const [visibleCount, setVisibleCount] = useState(3);

    const handleSeeMore = () => {
        setVisibleCount(prev => prev + 2); // load 2 more
    };

    const handleChanges = (event: any) => {
        const sortOption = event.target.value;
        setSortby(sortOption);

        if (sortOption === "") {
            setFeaturedCardData(allFeaturedCardData);
            return;
        }

        const sortedData = [...featuredCardData].sort((a: any, b: any) => {
            const nameA = (a.contactDetails?.name || '').toLowerCase();
            const nameB = (b.contactDetails?.name || '').toLowerCase();

            if (sortOption === "A - Z") {
                return nameA.localeCompare(nameB);
            } else if (sortOption === "Z - A") {
                return nameB.localeCompare(nameA);
            } else if (sortOption === "Recently joined") {
                const dateA = new Date(a.contactDetails?.createdDate || 0).getTime();
                const dateB = new Date(b.contactDetails?.createdDate || 0).getTime();
                return dateB - dateA;
            }
            return 0;
        });

        setFeaturedCardData(sortedData);
    };
    let recognition: any | null = null;
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLocalSearchInput(event.target.value);
        setSearchInput(event.target.value);
        filterJobs(allFeaturedCardData, selectedValues, event.target.value);
    };

    const handleMicHold = () => {
        setNotificationOpen(true);
        if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
            recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
            recognition.lang = 'en-US';
            recognition.onstart = () => {
                console.log('Speech recognition started');
            };
            recognition.onresult = (event: SpeechRecognitionEvent) => {
                const speechResult = event.results[0][0].transcript;
                setLocalSearchInput(speechResult);
                setSearchInput(speechResult);
                filterJobs(allFeaturedCardData, selectedValues, speechResult);
            };
            recognition.onerror = (event: { error: any }) => {
                console.error('Speech recognition error:', event.error);
            };
            recognition.onnomatch = (event: any) => {
                console.warn('No speech recognized:', event);
            };
            recognition.onspeechend = (event: any) => {
                console.log('Speech recognition ended:', event);
            };
            recognition.onend = () => {
                console.log('Speech recognition stopped');
                setNotificationOpen(false);
            };
            recognition.start();
        } else {
            console.log('Speech recognition not supported');
        }
    };

    useEffect(() => {
        const mentorsOnly = AllYourMentors.filter((item: {
            isMentor: boolean;
            mentorConnectionRequestSent?: boolean;
            mentorConnectionRequestRejected?: boolean;
        }) =>
            item.mentorConnectionRequestSent === true &&
            item.mentorConnectionRequestRejected !== true
        );
        setAllFeaturedCardData(mentorsOnly);
        setFeaturedCardData(mentorsOnly);
    }, []);
    const handleMicRelease = () => {
        if (recognition) {
            recognition.stop();
        }
    };
    const filterJobs = (jobs: any[], criteria: any, searchInput: string) => {
        // Map filter keys to correct mentor data structure
        const getNestedFieldValue = (job: any, key: string): any => {
            const pathMap: Record<string, string> = {
                locations: 'contactDetails.city',
                graduationYear: 'contactDetails.batch',
                currentCompany: 'contactDetails.company',
                postCompany: 'contactDetails.postCompany',
                industry: 'contactDetails.industry',
                // fallback for search fields
                City__c: 'contactDetails.city',
                Year_of_Graduation__c: 'contactDetails.batch',
                Industry__c: 'contactDetails.industry',
                Current_Company__c: 'contactDetails.company',
                Post_Company__c: 'contactDetails.postCompany',
            };
            const path = pathMap[key] || key;
            return path.split('.').reduce((obj, part) => obj?.[part], job);
        };

        const filteredJobs = jobs.filter((job: any) => {
            // Filtering by criteria
            const matchesCriteria = Object.keys(criteria).every((key) => {
                const selectedValues = criteria[key];
                if (!selectedValues || selectedValues.length === 0) return true;
                const jobValue = getNestedFieldValue(job, key);
                if (Array.isArray(selectedValues)) {
                    return selectedValues.includes(jobValue);
                }
                return jobValue === selectedValues;
            });

            // Search fields
            const searchFields = [
                'contactDetails.company',
                'contactDetails.designation',
                'contactDetails.industry',
                'contactDetails.interests',
                'contactDetails.name',
                'contactDetails.occupation',
                'contactDetails.postCompany',
                'contactDetails.program',
                'contactDetails.street',
                'contactDetails.batch',
            ];
            const matchesSearch = searchFields.some((field) => {
                const jobFieldValue = field.split('.').reduce((obj, part) => obj?.[part], job);
                return jobFieldValue?.toString().toLowerCase().includes(searchInput.toLowerCase());
            });

            return matchesCriteria && (searchInput ? matchesSearch : true);
        });
        setFeaturedCardData(filteredJobs);
    };
    const toggleFilter = () => {
        setIsFilterOpen(true);
    };
    const closeFilter = () => {
        setIsFilterOpen(false);
    };
    const handleFilterChange = (filterName: string, value: any) => {
        setSelectedValues((prevValues: any) => ({
            ...prevValues,
            [filterName]: value,
        }));
    };

    const applyFilters = () => {
        const filteredData = allFeaturedCardData.filter((user) => {
            const { locations, graduationYear, currentCompany, postCompany, industry } = selectedValues;
            const location = user?.contactDetails?.city;
            const year = user?.contactDetails?.batch;
            const company = user?.contactDetails?.company;
            const post = user?.contactDetails?.city;
            const ind = user?.contactDetails?.city;

            const locationMatches = locations.length ? locations.includes(location) : true;
            const yearMatches = graduationYear ? year === graduationYear : true;
            const companyMatches = currentCompany ? company === currentCompany : true;
            const postMatches = postCompany ? post === postCompany : true;
            const industryMatches = industry ? ind === industry : true;
            return locationMatches && yearMatches && companyMatches && postMatches && industryMatches;
        });
        setFeaturedCardData(filteredData);
    };
    const clearFilters = () => {
        setSelectedValues({
            locations: [],
            graduationYear: '',
            currentCompany: '',
            postCompany: '',
            industry: '',
        });
        setFeaturedCardData(allFeaturedCardData);
    };
    const getUniqueOptions = (field: string) => {
        // Map field to correct mentor data structure
        const fieldMap: Record<string, string> = {
            Year_of_Graduation__c: 'contactDetails.batch',
            Current_Company__c: 'contactDetails.company',
            Post_Company__c: 'contactDetails.postCompany',
            Industry__c: 'contactDetails.industry',
        };
        const mappedField = fieldMap[field] || field;
        return Array.from(new Set(allFeaturedCardData.map((user) => mappedField.split('.').reduce((obj, part) => obj?.[part], user))))
            .filter(Boolean);
    };
    const [showAll, setShowAll] = useState(false); // state moved to parent

    const handleToggleShowAll = () => {
        navigate('/mentorship/view-all-mentorship', {
            state: {
                title: 'Your Mentors',
                data: featuredCardData,
            },
        });

        setShowAll((prev) => !prev);
    };
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // State for modal
    const [openModal, setOpenModal] = useState(false);
    const [selectedCallRequest, setSelectedCallRequest] = useState<any>(null);

    // Modal open handler
    const handleOpenModal = (item: any) => {
        setSelectedCallRequest(item);
        setOpenModal(true);
    };

    // Modal close handler
    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedCallRequest(null);
    };

    const handleSortButtonClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleSortMenuClose = () => {
        setAnchorEl(null);
    };

    const handleSortSelect = (option: any) => {
        setSortby(option);
        setAnchorEl(null);
        handleChanges({ target: { value: option } });
    };

    return (
        <div>
            <Grid container style={{ height: "76.3vh" }}>
                <Grid item lg={9} xl={9} xs={12} style={{ backgroundColor: "white", borderRadius: "8px", padding: 15 }}>
                    <Grid style={{ marginBottom: 10 }} container display="flex" alignItems="center" justifyContent="space-between">
                        <Grid item md={3.5} lg={3.5} xl={3.5} xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography
                                sx={{
                                    fontSize: '15px',
                                    color: '#373A45',
                                    fontWeight: '500',
                                    textAlign: 'start',
                                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                                        fontSize: '12px !important',
                                    },
                                    '@media (min-width: 1920px) and (max-width: 1940px)': {
                                        fontSize: '20px !important',
                                    },
                                }}
                            >
                                {'Your Mentors'}
                            </Typography>
                            {isMobile && (
                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={handleToggleShowAll}
                                    sx={{
                                        ml: 2,
                                        textTransform: 'none',
                                        fontSize: '12px',
                                        backgroundColor: '#E8EBF3',
                                        color: '#5B4200',
                                        boxShadow: 'none',
                                        '&:hover': {
                                            backgroundColor: '#d3d7e3',
                                        },
                                    }}
                                >
                                    {showAll ? 'Show Less' : 'View All'}
                                </Button>
                            )}
                        </Grid>
                        <Grid item xs={12} sm={3} md={3} lg={3} xl={3} sx={{ display: { xs: 'none', sm: 'block' }, marginRight: 1 }} >
                            <AppSearchBar handleMicHold={handleMicHold} handleMicRelease={handleMicRelease} localSearchInput={localSearchInput} handleChange={handleChange} openSnackbar={notificationOpen} />
                        </Grid>
                        <Grid item xs={4} md={2} lg={2} xl={2} sx={{ display: { xs: 'none', sm: 'block' }, float: "right", marginTop: { xs: '10px', md: 0 }, marginBottom: { xs: '10px', md: 0 }, '@media (min-width: 1240px) and (max-width: 1280px)': { marginRight: 2 } }}>
                            <FormControl sx={{ width: '106%', float: "right", fontSize: "12px" }} size="small">
                                <Button
                                    variant="outlined"
                                    onClick={handleSortButtonClick}
                                    sx={{
                                        backgroundColor: '#E8EBF3',
                                        borderRadius: '8px',
                                        color: '#373A45',
                                        textTransform: 'none',
                                        fontWeight: 500,
                                        fontSize: 12,
                                        minWidth: 0,
                                        padding: '8px 18px 8px 16px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        boxShadow: 'none',
                                        border: 'none',
                                        '&:hover': {
                                            backgroundColor: '#d3d7e3',
                                            border: 'none',
                                        },
                                    }}
                                    endIcon={<img src={FilterIcon} alt='filter' />}
                                >
                                    {Sortby ? `${Sortby}` : "Sort by"}
                                </Button>
                                <Menu
                                    anchorEl={anchorEl}
                                    open={isSortMenuOpen}
                                    onClose={handleSortMenuClose}
                                    PaperProps={{
                                        sx: {
                                            borderRadius: 2,
                                            minWidth: 180,
                                            boxShadow: 3,
                                            mt: 1,
                                            backgroundColor: "#FFFFFF",
                                        }
                                    }}
                                >
                                    <MenuItem
                                        onClick={() => handleSortSelect("")}
                                        selected={Sortby === ""}
                                        sx={{ fontWeight: Sortby === "" ? 600 : 400 }}
                                    >
                                        Clear
                                    </MenuItem>
                                    {sortOptions.map(option => (
                                        <MenuItem
                                            key={option}
                                            onClick={() => handleSortSelect(option)}
                                            selected={Sortby === option}
                                            sx={{ fontWeight: Sortby === option ? 600 : 400 }}
                                        >
                                            {option}
                                        </MenuItem>
                                    ))}
                                </Menu>
                            </FormControl>
                        </Grid>
                        <Grid item xs={2} sm={1} md={1} lg={2} xl={1} sx={{ display: { xs: 'none', sm: 'block' } }}>
                            <Button
                                style={{
                                    color: "#373A45",
                                    backgroundColor: "#E8EBF3",
                                    borderRadius: 6,
                                    float: "right",
                                    fontSize: 14,
                                    padding: "7px 9px",
                                    width: '100%'
                                }}
                                endIcon={<FilterAltOutlinedIcon style={{ color: "#585A64" }} />}
                                onClick={toggleFilter}
                            >
                                {!isMobile && "Filters"}
                            </Button>
                        </Grid>
                        <Grid item md={1.8} lg={1.8} xl={1.8} sx={{ display: { xs: 'none', sm: 'block' } }}>
                            <Button
                                sx={{
                                    color: "#fff",
                                    backgroundColor: "#2C60AA",
                                    borderRadius: 2,
                                    float: "right",
                                    fontWeight: "500",
                                    padding: "9px",
                                    width: "100%",
                                    fontSize: 12,
                                    '@media (min-width: 1240px) and (max-width: 1280px)': {
                                        fontSize: 10,
                                    },
                                    '&:hover': {
                                        color: "#fff",
                                        backgroundColor: "#2C60AA",
                                    },
                                }}
                                onClick={() => { navigate(routes.setupPreference); }}
                            >
                                Edit preferences
                            </Button>
                        </Grid>
                        {isFilterOpen && (
                            <Grid>
                                <Paper
                                    className={`filter-modal ${classes.cardContainer2}`}
                                    style={{
                                        position: "absolute",
                                        right: "23%",
                                        backgroundColor: "white",
                                        width: "20%",
                                        zIndex: "1",
                                        border: "1px solid #bbbbbf",
                                        height: "70vh", // Fixed height
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ padding: "0 16px" }}>
                                        <Grid container>
                                            <Grid item md={6} style={{ justifyContent: "start", display: "flex", alignItems: "center" }}>
                                                <Box>
                                                    <Typography style={{ fontWeight: "500" }}>Filters</Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item md={6} style={{ justifyContent: "end", display: "flex", alignItems: "center" }}>
                                                <IconButton style={{ float: "right" }} onClick={closeFilter}>
                                                    <CloseIcon />
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                    </Box>

                                    <Box
                                        textAlign="left"
                                        sx={{
                                            flex: 1,
                                            overflowY: "auto",
                                            padding: 2,
                                            paddingBottom: 1
                                        }}
                                    >
                                        <InputLabel id="location-label" style={{ fontSize: 14, marginTop: 6 }}>Location</InputLabel>
                                        <FormControl style={{ width: '100%', marginTop: 0 }} size="small" margin="normal">
                                            <Select
                                                labelId="location-label"
                                                multiple
                                                value={selectedValues.locations}
                                                onChange={(e) => handleFilterChange('locations', e.target.value)}
                                                renderValue={(selected) => selected.join(', ')}
                                            >
                                                {Array.from(new Set(allFeaturedCardData.map((user) => user?.contactDetails?.city)))
                                                    .map((city) => (
                                                        <MenuItem key={city} value={city}>
                                                            {city}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                        </FormControl>

                                        <InputLabel id="year-label" style={{ fontSize: 14, marginTop: 6 }}>Year of Graduation</InputLabel>
                                        <FormControl style={{ width: '100%', marginTop: 0 }} size="small" margin="normal">
                                            <Select
                                                labelId="year-label"
                                                value={selectedValues.graduationYear}
                                                onChange={(e) => handleFilterChange('graduationYear', e.target.value)}
                                            >
                                                {getUniqueOptions('Year_of_Graduation__c').map((year) => (
                                                    <MenuItem key={year} value={year}>
                                                        {year}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        <InputLabel id="company-label" style={{ fontSize: 14, marginTop: 6 }}>Current Company</InputLabel>
                                        <FormControl style={{ width: '100%', marginTop: 0 }} size="small" margin="normal">
                                            <Select
                                                labelId="company-label"
                                                value={selectedValues.currentCompany}
                                                onChange={(e) => handleFilterChange('currentCompany', e.target.value)}
                                            >
                                                {getUniqueOptions('Current_Company__c').map((company) => (
                                                    <MenuItem key={company} value={company}>
                                                        {company}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        <InputLabel id="post-company-label" style={{ fontSize: 14, marginTop: 6 }}>Post Company</InputLabel>
                                        <FormControl style={{ width: '100%', marginTop: 0 }} size="small" margin="normal">
                                            <Select
                                                labelId="post-company-label"
                                                value={selectedValues.postCompany}
                                                onChange={(e) => handleFilterChange('postCompany', e.target.value)}
                                            >
                                                {getUniqueOptions('Post_Company__c').map((postCompany) => (
                                                    <MenuItem key={postCompany} value={postCompany}>
                                                        {postCompany}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        <InputLabel id="industry-label" style={{ fontSize: 14, marginTop: 6 }}>Industry</InputLabel>
                                        <FormControl style={{ width: '100%', marginTop: 0 }} size="small" margin="normal">
                                            <Select
                                                labelId="industry-label"
                                                value={selectedValues.industry}
                                                onChange={(e) => handleFilterChange('industry', e.target.value)}
                                            >
                                                {getUniqueOptions('Industry__c').map((industry) => (
                                                    <MenuItem key={industry} value={industry}>
                                                        {industry}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>

                                    <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        sx={{
                                            padding: 2,
                                            backgroundColor: 'white',
                                            marginTop: 'auto'
                                        }}
                                    >
                                        <Button onClick={clearFilters} sx={{ color: "#373A45" }}>Clear</Button>
                                        <Button onClick={applyFilters}  sx={{   
    background: '#2C60AA',
    color: '#fff',
    '&:hover': {
      background: '#2C60AA',
      color: '#fff',
    },
  }}>Apply</Button>
                                    </Box>
                                </Paper>
                            </Grid>
                        )}
                    </Grid>
                    {isMobile ? (
                        <MentorshipMobileview cardData={featuredCardData} title={''} showAll={showAll} />
                    ) : (
                        <Grid className={`scrollbar-cusgray ${classes.cardContainer}`}>
                            <MentorshipContainer cardData={featuredCardData} title={''} type={'mentors'} showAll={showAll} />
                        </Grid>
                    )}
                </Grid>
                <Grid item lg={3} xl={3} xs={12} style={{ marginTop: '10px' }}>
                    <Grid sx={{
                        backgroundColor: "white", borderRadius: "8px", padding: 2, ml: { xs: 0, sm: 2 }, marginBottom: 2, height: {
                            xs: "auto",
                            sm: "auto",
                            md: '47% !important'
                        }
                    }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', padding: 1, fontWeight: 500 }}>
                            Call requests you sent
                        </Box>
                        <Grid style={{ minHeight: isMobile ? "auto" : '200px', maxHeight: isMobile ? "auto" : "400px", overflowY: 'auto' }}>
                            {CallrequestbymeData.length === 0 ? (
                                <Box sx={{ textAlign: 'center', py: 3, color: '#888', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                    <img src={RequestImage} alt="No Requests" style={{ width: 72, marginBottom: 16 }} />
                                    <Typography variant="body2" sx={{ color: '#585A64', fontSize: 14, fontWeight: 500 }}>
                                        -No Call Requests-
                                    </Typography>
                                </Box>) : <>
                                {CallrequestbymeData.slice(0, visibleCount).map((item: any, index: any) => {
                                    return (
                                        <Grid
                                            container
                                            key={index}
                                            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                                        >
                                            <Grid item md={2.5} lg={2.5} xl={2.5} xs={2.5} style={{ textAlign: "left", marginTop: 10 }}>
                                                <img
                                                    src={item?.userImageUrl || 'https://thumbs.dreamstime.com/b/default-profile-picture-avatar-photo-placeholder-vector-illustration-default-profile-picture-avatar-photo-placeholder-vector-189495158.jpg'}
                                                    alt='profile'
                                                    style={{ width: 45, height: 45, borderRadius: "50%" }}
                                                />
                                            </Grid>
                                            <Grid item md={5.5} lg={5.5} xl={5.5} xs={5.5} style={{ textAlign: "left", marginTop: 10 }}>
                                                <Typography style={{ fontSize: "12px", fontWeight: 500 }}>
                                                    {item?.meetWithUser || 'Name not available'}
                                                </Typography>
                                                <Typography style={{ fontSize: "14px", color: "#373A45" }}>
                                                    {item?.meetTitle || 'Meet Title'}
                                                </Typography>
                                            </Grid>
                                            <Grid item md={4} lg={4} xl={4} xs={4}
                                                style={{ textAlign: "left", marginTop: 10, display: "flex", justifyContent: "space-between" }}
                                            >
                                                <Button
                                                    style={{ fontSize: "12px", fontWeight: 500, backgroundColor: "white", color: "#2C60AA", textDecoration: "underline" }}
                                                    onClick={() => handleOpenModal(item)}
                                                >
                                                    View Details
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    );
                                })}
                                {visibleCount < CallrequestbymeData.length && (
                                    <Box sx={{ textAlign: 'center', mt: 2 }}>
                                        <Button
                                            onClick={handleSeeMore}
                                            style={{
                                                borderRadius: 4,
                                                padding: '6px 12px',
                                                fontSize: 14,
                                                cursor: 'pointer',
                                            }}
                                        >
                                            View More
                                        </Button>
                                    </Box>
                                )}
                            </>
                            }
                        </Grid>
                    </Grid>
                    <Grid sx={{ backgroundColor: "white", borderRadius: "8px", padding: 2, ml: { xs: 0, sm: 2 }, marginBottom: 2, height: "49%" }}>
                        <Grid>
                            <Typography>Upcoming calls</Typography>
                            <hr style={{ opacity: ".15" }} />
                            <Grid>
                                {upcomingCalls && Array.isArray(upcomingCalls) && upcomingCalls.length > 0 ? (
                                    <Upcomingcalls upcomingCalls={upcomingCalls} />
                                ) : (
                                    <Typography>No upcoming calls available</Typography>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {/* Modal for call request details */}
            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="call-request-details-title"
                aria-describedby="call-request-details-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 370,
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 3,
                        outline: 'none',
                        maxHeight: '90vh',
                        overflowY: 'auto',
                    }}
                >
                    <IconButton
                        onClick={handleCloseModal}
                        sx={{ position: 'absolute', top: 8, right: 8 }}
                        size="small"
                    >
                        <CloseIcon />
                    </IconButton>
                    {selectedCallRequest && (
                        <Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                <img
                                    src={selectedCallRequest.userImageUrl || 'https://thumbs.dreamstime.com/b/default-profile-picture-avatar-photo-placeholder-vector-illustration-default-profile-picture-avatar-photo-placeholder-vector-189495158.jpg'}
                                    alt="profile"
                                    style={{ width: 60, height: 60, borderRadius: "50%", marginRight: 16 }}
                                />
                                <Box>
                                    <Typography sx={{ fontWeight: 600, fontSize: 18 }}>
                                        {selectedCallRequest.meetWithUser || 'Name not available'}
                                    </Typography>
                                    <Typography sx={{ color: '#666', fontSize: 14 }}>
                                        {selectedCallRequest.designation || ''} {selectedCallRequest.company ? `@ ${selectedCallRequest.company}` : ''}
                                    </Typography>
                                    <Typography sx={{ color: '#888', fontSize: 13 }}>
                                        {selectedCallRequest.city || ''} {selectedCallRequest.batch ? `• Batch: ${selectedCallRequest.batch}` : ''}
                                    </Typography>
                                </Box>
                            </Box>
                            <Divider sx={{ mb: 2 }} />
                            <Typography sx={{ fontWeight: 500, mb: 1 }}>Meeting Details</Typography>
                            <Box sx={{ mb: 1 }}>
                                <Typography variant="body2" sx={{ color: '#888' }}>Title</Typography>
                                <Typography sx={{ fontWeight: 500 }}>{selectedCallRequest.meetTitle}</Typography>
                            </Box>
                            <Box sx={{ mb: 1 }}>
                                <Typography variant="body2" sx={{ color: '#888' }}>Date</Typography>
                                <Typography sx={{ fontWeight: 500 }}>{selectedCallRequest.meetDate}</Typography>
                            </Box>
                            <Box sx={{ mb: 1 }}>
                                <Typography variant="body2" sx={{ color: '#888' }}>Start Time</Typography>
                                <Typography sx={{ fontWeight: 500 }}>{selectedCallRequest.meetStarttime}</Typography>
                            </Box>
                            <Box sx={{ mb: 1 }}>
                                <Typography variant="body2" sx={{ color: '#888' }}>End Time</Typography>
                                <Typography sx={{ fontWeight: 500 }}>{selectedCallRequest.meetEndtime}</Typography>
                            </Box>
                            <Box sx={{ mb: 1 }}>
                                <Typography variant="body2" sx={{ color: '#888' }}>Mode</Typography>
                                <Typography sx={{ fontWeight: 500 }}>{selectedCallRequest.meetMode}</Typography>
                            </Box>
                            {selectedCallRequest.meetLink && (
                                <Box sx={{ mb: 1 }}>
                                    <Typography variant="body2" sx={{ color: '#888' }}>Meeting Link</Typography>
                                    <Typography sx={{ fontWeight: 500, wordBreak: 'break-all' }}>{selectedCallRequest.meetLink}</Typography>
                                </Box>
                            )}
                            {selectedCallRequest.meetDescription && (
                                <Box sx={{ mb: 1 }}>
                                    <Typography variant="body2" sx={{ color: '#888' }}>Description</Typography>
                                    <Typography sx={{ fontWeight: 500 }}>{selectedCallRequest.meetDescription}</Typography>
                                </Box>
                            )}
                            {selectedCallRequest.program && (
                                <Box sx={{ mb: 1 }}>
                                    <Typography variant="body2" sx={{ color: '#888' }}>Program</Typography>
                                    <Typography sx={{ fontWeight: 500 }}>{selectedCallRequest.program}</Typography>
                                </Box>
                            )}
                        </Box>
                    )}
                </Box>
            </Modal>
        </div>
    );
}
export default YourMentors;